import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import {
  GetOfflineHeadsetsQueryParams,
  GetOfflineHeadsetsResponse,
} from './offlineHeadsets.types';

export const getOfflineHeadsetsAPI = async ({
  params,
}: {
  params: GetOfflineHeadsetsQueryParams;
}): Promise<AxiosResponse<GetOfflineHeadsetsResponse & ApiError>> => {
  return instance
    .get<GetOfflineHeadsetsResponse>('/offline_devices', {
      params,
    })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
